import type { ApiClient } from "./client";
import type { SearchResults } from "./types";

/** Search: domain operations the UI depends on. Implementations: HTTP (below) and mock (src/api/mock). */
export interface SearchApi {
  global(q: string): Promise<SearchResults>;
}

export function createHttpSearchApi(client: ApiClient): SearchApi {
  return {
    global: (q) => client.call("searchGlobal", { query: { q } }),
  };
}
